export const SET_BULK_OPERATIONS_STATUS = "set-bulk-operations-status"


// WEBPACK FOOTER //
// ./src/state/bulk-operation/BulkOperationStatusActionTypes.ts